import GridStack from 'gridstack/dist/gridstack-all';

if($('.grid-stack').length) {
    let grid = GridStack.init({
        acceptWidgets: ".grid-stack-item",
        removable: true,
        float: true,
        alwaysShowResizeHandle: 'mobile',
    });

    GridStack.setupDragIn('.newWidget', {appendTo: 'body', helper: 'clone'});

    grid.on("dropped", function(e, prevWidget, newWidget) {
        newWidget.el.getElementsByTagName("canvas")[0].removeAttribute("hidden");
    });

    grid.on('removed', function(e, items) {
    });

    if(isMobile) {
        grid.float(false);
        grid.column(1);
        adjustItemSizes(1);
    }
}

function adjustItemSizes(columns) {
    let items = document.querySelectorAll('.grid-stack-item');
    items.forEach(item => {
        if (columns === 1) {
            item.setAttribute('gs-w', '1'); // Set width to 1 for single column
            item.setAttribute('gs-h', '2'); // Set height to 1 for single column
        } else {
            item.setAttribute('gs-w', item.getAttribute('data-default-w') || '1'); // Default width for multiple columns
            item.setAttribute('gs-h', item.getAttribute('data-default-h') || '1'); // Default height for multiple columns
        }
    });
}
